import logo from '../logo.svg';
// import '../App.css';
import React, { useEffect, useState } from "react";
// src/components/TopBar.jsx


function TopBar() {
const [username, setUsername] = useState(null);

useEffect(() => {

  const storedUser =
    localStorage.getItem("username");

  if (storedUser) {
    setUsername(storedUser);
  }

}, []);
  return (

    <div
      className="
        hidden
        lg:block
        w-full
        bg-white/95
        backdrop-blur-md
        border-b
        border-gray-200
      "
    >

      <div
        className="
          px-6
          xl:px-10
          h-[45px]
          flex
          items-center
          justify-between
        "
      >

        {/* =========================
            LEFT SIDE
        ========================= */}

        <div
          className="
            flex
            items-center
            gap-6
            text-sm
            text-gray-600
          "
        >

          <a
            href="#"
            className="
              flex
              items-center
              gap-2
              hover:text-gray-700
              transition
            "
          >
            <span className="text-gray-700">📍</span>
            Find A Location
          </a>

          <a
            href="tel:+919861615950"
            className="
              flex
              items-center
              gap-2
              hover:text-gray-700
              transition
            "
          >
            <span className="text-gray-700">📞</span>
            +91 9861615950
          </a>

          <a
            href="mailto:info@orionics.in"
            className="
              flex
              items-center
              gap-2
              hover:text-gray-700
              transition
            "
          >
            <span className="text-gray-700">✉️</span>
            info@orionics.in
          </a>

        </div>

        {/* =========================
            RIGHT SIDE
        ========================= */}

        <div
          className="
            flex
            items-center
            gap-6
            text-sm
          "
        >

          {!username ? (

            <>
              <a
                href="/register"
                className="
                  text-gray-700
                  hover:text-green-700
                  transition
                  flex
                  items-center
                  gap-2
                "
              >
                <span className="text-green-700">👤</span>
                Register
              </a>

              <a
                href="/login"
                className="
                  text-gray-700
                  hover:text-green-700
                  transition
                  flex
                  items-center
                  gap-2
                "
              >
                <span className="text-green-700">🔑</span>
                Login
              </a>
            </>

          ) : (

            <>
              {/* USERNAME */}

              <div
                className="
                  text-gray-700
                  font-medium
                "
              >
                Hi, {username}
              </div>

              {/* DASHBOARD MENU */}

              <div className="relative group">

                <button
                  className="
                    flex
                    items-center
                    gap-2
                    text-gray-700
                    hover:text-green-700
                    transition
                  "
                >

                  <span className="text-green-700">
                    🏠
                  </span>

                  My Dashboard

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>

                </button>

                {/* DROPDOWN */}

                <div
                  className="
                    absolute
                    right-0
                    top-8
                    w-56
                    bg-white
                    rounded-2xl
                    shadow-2xl
                    border
                    border-gray-100
                    py-2
                    opacity-0
                    group-hover:opacity-100
                    group-hover:visible
                    transition-all
                  "
                >

                  <a
                    href="/myportfolio/"
                    className="
                      block
                      px-5
                      py-3
                      hover:bg-green-50
                      transition
                    "
                  >
                    My Portfolio
                  </a>

                  <button
                    className="
                      w-full
                      text-left
                      px-5
                      py-3
                      hover:bg-red-50
                      text-red-600
                      transition
                    "
                    onClick={() => {

                      localStorage.removeItem("username");

                      if (window.handleLogout) {
                        window.handleLogout();
                      } else {
                        window.location.href = "/";
                      }

                    }}
                  >
                    Log Out
                  </button>

                </div>

              </div>

            </>

          )}

        </div>

      </div>

    </div>

  );

}

export default TopBar;